import { transformToArray } from '../../utils/TranslationUtil';
import { languageList } from '../../utils/LocaleUtil/languageList';

const companyName = 'Expedia Group.';

// following locales don't use short names
const lpsShortNameExclusions = {
    zh_CN: 'zh-cn',
    zh_TW: 'zh-TW',
    pt_PT: 'pt-pt',
    pt_BR: 'pt-br'
};

export const eglinks = {
    expedia: {
        termsOfUse: 'https://welcome.expediagroup.com/{localeShort}/terms-of-use',
        privacyPolicy: 'https://welcome.expediagroup.com/{localeShort}/privacy-policy',
        cookiePolicy: 'https://welcome.expediagroup.com/{localeShort}/expedia-group-cookie-policy',
        partnerHelp: 'https://apps.expediapartnercentral.com/lodging/help/overview.html?langId={langId}',
        euVacationAgreement: 'https://api.expediapartnercentral.com/contract/ext/templatepdf?language={langId}&version=330'
    },
    eg: {
        faqs: 'https://apps.expediapartnercentral.com/lodging/help/overview',
        signIn: 'https://www.expediapartnercentral.com/Account/Logon?langId={langId}',
        inclusionStatement: 'https://apps.expediapartnercentral.com/lodging/help/help-article/property/property-administration/inclusion-statement-guidelines?langId={langId}&domain=HOTEL',
        aboutUs: 'https://welcome.expediagroup.com/{localeShort}/about-us'
    }
};

const DEFAULT_LOCALE = 'en_US';
const DEFAULT_SHORT_NAME = 'en';

const getLanguage = (locale) => languageList.find((lang) => lang.locale === locale)
    || getLanguage(DEFAULT_LOCALE);

const getLocaleShortName = (locale) => lpsShortNameExclusions[locale]
    || (locale && locale.split('_')[0]) || DEFAULT_SHORT_NAME;

const getExpediaLinks = (locale) => {
    const language = getLanguage(locale);
    const shortName = getLocaleShortName(locale);
    const expediaLinks = eglinks.expedia;

    return transformToArray({
        termsOfUse: expediaLinks.termsOfUse.replace('{localeShort}', shortName),
        privacyPolicy: expediaLinks.privacyPolicy.replace('{localeShort}', shortName),
        cookiePolicy: expediaLinks.cookiePolicy.replace('{localeShort}', shortName),
        partnerHelp: expediaLinks.partnerHelp.replace('{langId}', language.langId),
        euVacationAgreement: expediaLinks.euVacationAgreement.replace('{langId}', language.langId)
    });
};

const getEgLinks = (locale) => {
    const language = getLanguage(locale);
    const shortName = getLocaleShortName(locale);
    const egLinks = eglinks.eg;

    return {
        column1: transformToArray({
            faqs: egLinks.faqs.replace('{localeShort}', shortName),
            signIn: egLinks.signIn.replace('{langId}', language.langId)
        }),
        column2: transformToArray({
            inclusionStatement: egLinks.inclusionStatement.replace('{langId}', language.langId),
            aboutUs: egLinks.aboutUs.replace('{localeShort}', shortName)
        })
    };
};

export {
    getExpediaLinks,
    getEgLinks,
    companyName
};
